export const INT_WEB_CSV_TOAST_SEND_CAMPAIGN =
  "int_web_csv_toast_send_campaign";
export const INT_CREATE_OTC = "int_create_otc";
export const INT_CREATE_OGC = "int_create_ogc";
